module.exports = __webpack_public_path__ + "img/Inicio4.972e9c57.png";